import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { adminToken, hasPermission } = useAdmin();

  useEffect(() => {
    // Prevent caching for authenticated routes
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        window.location.href = "/";
      }
    };
  }, []);

  // Check if user is authenticated
  const isAuthenticated = adminToken || localStorage.getItem("token");
  
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // If no specific permission is required, just check authentication
  if (!requiredPermission) {
    return children;
  }

  // Check if user has the required permission
  if (!hasPermission(requiredPermission)) {
    // Redirect to dashboard or show access denied
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
